export default __webpack_public_path__ + "static/media/warningIcon.5712dbec.svg";